import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  skuColumnHeader: {
    defaultMessage: 'SKU',
    id: 'wS8TtU',
    description: 'SKU Column Header',
  },
  nameColumnHeader: {
    defaultMessage: 'Item name',
    id: 'y3hU2F',
    description: 'Item name Column Header',
  },
  quantityColumnHeader: {
    defaultMessage: 'Qty to Send',
    id: 'bLwmV6',
    description: 'Quantity Column Header',
  },
  recievedQuantityColumnHeader: {
    defaultMessage: 'Qty Received',
    id: '9S5mgK',
    description: 'Received Quantity Column Header',
  },
  dangerousGoodsColumnHeader: {
    defaultMessage: 'Dangerous Good',
    id: 'VsMwrx',
    description: 'Dangerous Good Column Header',
  },
  actionsColumnHeader: {
    defaultMessage: 'Actions',
    id: 'kel+Ry',
    description: 'Actions Column Header',
  },
  dangerousGoodsYes: {
    defaultMessage: 'Yes',
    id: 'g00zXy',
    description: 'Dangerous Goods Yes',
  },
  dangerousGoodsNo: {
    defaultMessage: 'No',
    id: 'Uclqfp',
    description: 'Dangerous Goods No',
  },
});
